/* ─────────────────────────────────────────────────
   VERA PLANT — THEME JS
───────────────────────────────────────────────── */
document.addEventListener('DOMContentLoaded', function () {

  /* ── FAQ accordion ── */
  document.querySelectorAll('.faq-item__q').forEach(function (q) {
    q.addEventListener('click', function () {
      var item = q.closest('.faq-item');
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.faq-item').forEach(function (i) { i.classList.remove('open'); });
      if (!isOpen) item.classList.add('open');
    });
  });

  /* ── How-it-works accordion ── */
  document.querySelectorAll('.how-step').forEach(function (step) {
    step.addEventListener('click', function () {
      document.querySelectorAll('.how-step').forEach(function (s) { s.classList.remove('active'); });
      step.classList.add('active');
    });
  });

  /* ── Variant / pack selector ── */
  window.selectVariant = function (btn) {
    document.querySelectorAll('.pack-btn').forEach(function (b) { b.classList.remove('selected'); });
    btn.classList.add('selected');
    var variantId = btn.getAttribute('data-variant-id');
    var price     = btn.getAttribute('data-price');
    var compare   = btn.getAttribute('data-compare');
    var vidInput  = document.getElementById('variantId');
    if (vidInput) vidInput.value = variantId;
    var pm = document.getElementById('priceMain');
    var po = document.getElementById('priceOld');
    var ps = document.getElementById('priceSave');
    if (pm && price) pm.textContent = price;
    if (po) { po.textContent = compare && compare !== 'null' ? compare : ''; }
    if (ps) { ps.style.display = compare && compare !== 'null' ? '' : 'none'; }
    /* ── Switch variant image ── */
    var imgSrc = btn.getAttribute('data-image');
    if (imgSrc) {
      var mainImg = document.getElementById('mainImg');
      if (mainImg) { mainImg.srcset = ''; mainImg.src = imgSrc; }
      var imgFile = imgSrc.split('?')[0].split('/').pop();
      var thumbs = Array.from(document.querySelectorAll('.gallery-thumb[data-src]'));
      thumbs.forEach(function (t) { t.classList.remove('active'); });
      thumbs.forEach(function (t) {
        if ((t.getAttribute('data-src') || '').split('?')[0].split('/').pop() === imgFile) {
          t.classList.add('active');
        }
      });
    }
  };

  /* ── Gallery thumbnail switching ── */
  document.querySelectorAll('.gallery-thumb').forEach(function (thumb, idx) {
    thumb.addEventListener('click', function () {
      document.querySelectorAll('.gallery-thumb').forEach(function (t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      var images = document.querySelectorAll('.gallery-col__main img');
      if (images[idx]) {
        var mainImg = document.getElementById('mainImg');
        if (mainImg) mainImg.src = images[idx].src;
      }
    });
  });

  /* ── Collection filter tabs ── */
  window.filterProducts = function (cat, clickedTab) {
    document.querySelectorAll('.filter-tab').forEach(function (t) { t.classList.remove('active'); });
    if (clickedTab) clickedTab.classList.add('active');
    document.querySelectorAll('.prod-card').forEach(function (card) {
      var cardCat = card.getAttribute('data-cat');
      card.style.display = (cat === 'all' || cardCat === cat) ? '' : 'none';
    });
  };

  window.handleSort = function (val) {
    var grid = document.querySelector('.collection-grid');
    if (!grid) return;
    var cards = Array.from(grid.querySelectorAll('.prod-card'));
    cards.sort(function (a, b) {
      if (val === 'price-asc') return parseFloat(a.dataset.price || 0) - parseFloat(b.dataset.price || 0);
      if (val === 'price-desc') return parseFloat(b.dataset.price || 0) - parseFloat(a.dataset.price || 0);
      if (val === 'alpha')  return (a.dataset.name || '').localeCompare(b.dataset.name || '');
      return 0;
    });
    cards.forEach(function (c) { grid.appendChild(c); });
  };

  /* ── AJAX add-to-cart (optional enhancement) ── */
  var atcForms = document.querySelectorAll('.product-form');
  atcForms.forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var btn = form.querySelector('.atc-btn');
      if (!btn) return;
      btn.textContent = 'Se adaugă...';
      btn.disabled = true;
      setTimeout(function () {
        btn.textContent = '✓ Adăugat în Coș';
        btn.style.background = 'var(--green)';
        updateCartCount();
        setTimeout(function () {
          btn.textContent = 'Adaugă în Coș';
          btn.style.background = '';
          btn.disabled = false;
        }, 2200);
      }, 600);
    });
  });

  /* ── Mobile hamburger menu ── */
  var hamburger = document.querySelector('.nav__hamburger');
  var mobileMenu = document.querySelector('.nav__mobile-menu');
  if (hamburger && mobileMenu) {
    hamburger.addEventListener('click', function () {
      mobileMenu.classList.toggle('open');
    });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        document.querySelectorAll('.cart-count').forEach(function (el) {
          el.textContent = '(' + data.item_count + ')';
        });
      })
      .catch(function () {});
  }

});